export default "__VITE_ASSET__CNQE6quU__"